import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Score = types.compose(
  BaseEntity,
  types.model('Score', {
    // scoreId: types.maybe(types.identifierNumber),
    feasible: types.maybe(types.boolean),
    hardScore: types.maybe(types.number),
    initScore: types.maybe(types.integer),
    mediumScore: types.maybe(types.number),
    softScore: types.maybe(types.number),  //BigDecimal
    solutionInitialized: types.maybe(types.boolean),
  }),
);
